import { FormattedDateTime } from "@edgetier/client-components";
import { FunctionComponent, memo } from "react";

import AnomalySummaryValue from "../anomaly-summary-value";

import { IProps } from "./anomaly-end-date-time.types";
import "./anomaly-end-date-time.scss";

/**
 * Display the end time of an anomaly, which may not exist if the anomaly is still active.
 * @param props.endDateTime End time of the anomaly.
 * @returns                 Formatted date time or string.
 */
const AnomalyEndDateTime: FunctionComponent<IProps> = ({ endDateTime }) => {
    return (
        <AnomalySummaryValue title="Anomaly End">
            {endDateTime instanceof Date ? <FormattedDateTime dateTime={endDateTime} /> : <>Ongoing</>}
        </AnomalySummaryValue>
    );
};

export default memo(AnomalyEndDateTime);
